export const environment = {
  production: false,
  name: 'dev',
  iframeBaseUrl: 'https://developer-portal-dev.gtn.tech/trade',
  iframeUrl:
    'https://developer-portal-dev.gtn.tech/trade/docs/getting-started/introduction/',
  fixIframeUrl:
    'https://fintech-api.globaltradingnetwork.com/docs/apis/trade/Trade-Management/fix-api',
  backOfficeIframeUrl:
    'https://gtn-dev.stoplight.io/docs/external-service-multiple-test/035e964642eed-create-individual-investor-account',
  microInvestingIframeBaseUrl: 'https://developer-portal-dev.gtn.tech/microinvest',
  microInvestingIframeUrl: 'https://developer-portal-dev.gtn.tech/microinvest/docs/1.1.0/apis/authentication/generate-server-auth-token',
  investApiIframeBaseUrl: 'https://developer-portal-dev.gtn.tech/invest',
  investApiIframeUrl: 'https://developer-portal-dev.gtn.tech/invest/docs/1.0.0/apis/authentication/get-server-token',
  keyGenAppUrl: 'https://dev-keygen.gtn.tech/',
  assertionGenAppUrl: 'https://dev-assertiongen.gtn.tech',
  base64EncoderUrl: 'https://dev-base64encoder.gtn.tech/',

  keycloakConfig: {
    url: 'https://developer-portal-dev.gtn.tech/',
    realm: 'devportal-prod-realm',
    clientId: 'gtn-devportal-webapp',
  },

  redirectUri: 'https://developer-portal-dev.gtn.tech',

  recaptcha: {
    siteKey: '6Lfq62UrAAAAAH1jC0IqPcmJLtkdZ6Ugh5mcKnzo',
  },

  signInPath: "/signin",
  signupPath: "/signup",
  tokenRefreshPath: "/authentication/refreshCustomerAuthToken",
  profileDetailsPath: "/profile-details",
  countryListPath: "/country-list",
  profileEditPath: "/broker/edit",
  deleteBrokerPath: "/broker/delete",
  approveBrokerPath: "/broker/approve",
  brokerCreatePath: "/broker/create",
  brokerRequestPath: "/broker/request",
  changeBrokerPasswordPath: "/broker/change-password",
  priceAuthRefreshPath: "/authenticate",
  priceAuthAccessPath: "/auth/token",
  institutionListPath: "/institution-list",
  validateUserNamePath: '/broker/validateUsername',
  rejectBrokerRequestPath: "/pending-broker/reject",
  resetPasswordPath: "/reset-password",
  institutionalApiListByInstitutionIdPath : "/institutional-api-list-by-id",
  institutionalApiListByInstitutionCodePath : "/institutional-api-list-by-code",
  normalBrokerCreatePath: "/broker/create/by-brokerAdmin",
  normalBrokerProfileEditPath: "/broker/edit/by-brokerAdmin",
  sortedFilteredUsersDetailsPath: "/portal-users-list",
  sortedFilteredPendingUsersDetailsPath: "/pending-users-list",
  institutionListPaginationPath:"/paginated-institution-list",
  instExchangesListPath : "/inst-exchanges-list",
  bankAccountDetailsPath: "/institution/bank/account-all",
  instBankListPath : "/institution/bank-all",
  instCustomerProfilePath : "/customer/profiles",
  instSubscriptionPackageListPath : "/subscriptionPackage-all",
  institutionDetailsPath : "/institution-details-by-code",
  customerDetails: "/customer-account",
  customerDetailsByCustomerId: "/customer-account-by-id",
  saveAppCredentialsPath: "/save-app-credentials",
  currencyListPath: "/currency-details",
  addTradeLimitPath:"/institution/institution-trade-limits",
  addMasterTradeLimitPath:"/institution/master-trade-limits",
  getInstitutionPath: "/institution",
  createCashAccountPath: "/cash-account",
  createSecurityAccountPath: "/security-account",
  createExchangeAccountPath: "/exchange-account",
  exchangeAccountTradingEnablePath: "/trading-enable",

  executingBrokerListPath : "/executing-brokers",
  defaultValuesOfExchange:"/default-values-of-exchange",
  unassignedExchangesPath: "/unassigned-exchange-list",
  instSubscriptionPackageByIdPath: "/subscriptionPackage",
  updateSubscriptionPackage:"/subscriptionPackage",
  addSubscriptionPackage:"/subscriptionPackage",
  defaultSubscriptionPackPath: "/subscriptionPackage-default",
  defaultProfilePath: "/customer-profile-default",
  customerProfileCreation:"/customer-profile",
  createMasterAccountPath: "/institution/master-account",
  validateInstCodePath: '/find-institution',
  addInstitutionPath: "/institution",
  instAssignExchangesPath : "/institution/assign-exchanges",
  addInstBankAccPath : "/institution/bank/account",
  unassignedInstBanksPath: "/institution/bank/unassigned",
  instBankAssignPath: "/institution/bank-assign",
  getAdminDashboardData: "/get-response-codes",
  validateCaptchaToken: '/broker/validateCaptchaToken',
  generatePreSignedUrl: '/generate-presigned-url',
  institutionConfigs: '/inst-configs',
  generateS3UploadUrl: '/file-upload/generate-s3-upload-url',
  triggerPipeline: '/file-upload/trigger-pipeline',
  defaultS3BucketPath: 'confluence-to-markdown/',


  devBaseUrl :'http://localhost:8724',
  qABaseUrl:'https://api-qa.globaltradingnetwork.com',
  sandboxBaseUrl:'https://sandbox.globaltradingnetwork.com',
  asiaUATBaseUrl:'https://api-asia-uat.globaltradingnetwork.com',
  menaUATBaseUrl:'https://api-mena-uat.globaltradingnetwork.com',
  europeUATBaseUrl:'https://api-europe-uat.globaltradingnetwork.com',
  usUATBaseUrl:'https://api-americas-uat.globaltradingnetwork.com',
  hkUATBaseUrl:'https://hkuat.gtn.tech',
  asiaProdBaseUrl:'https://api-asia.globaltradingnetwork.com',
  menaProdBaseUrl:'https://api-mena.globaltradingnetwork.com',
  europeProdBaseUrl:'https://api-europe.globaltradingnetwork.com',
  usProdBaseUrl:'https://api-americas.globaltradingnetwork.com',
  hkProdBaseUrl:'https://api-hk.gtn.tech',


};
